module.exports = __webpack_public_path__ + "static/media/31-1.e2ee8368.mp3";